
const checkProv = function (val) {
  const pattern = /^[1-9][0-9]/;
  const provs = {11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",83:"台湾"};
  if(pattern.test(val)) {
    if(provs[val]) {
      return true;
    }
  }
  return false;
}
const checkDate = function (val) {
  const pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
  if(pattern.test(val)) {
    const year = val.substring(0, 4);
    const month = val.substring(4, 6);
    const date = val.substring(6, 8);
    const date2 = new Date(year+"-"+month+"-"+date);
    if(date2 && date2.getMonth() == (parseInt(month) - 1)) {
      return true;
    }
  }
  return false;
}
const checkCode = function (val) {
  const p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  const factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
  const parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
  const code = val.substring(17);
  if(p.test(val)) {
    let sum = 0;
    for(let i=0;i<17;i++) {
      sum += val[i]*factor[i];
    }
    if(parity[sum % 11] == code.toUpperCase()) {
      return true;
    }
  }
  return false;
}
export const checkID = function (val) {
  if(checkCode(val)) {
    const date = val.substring(6,14);
    if(checkDate(date)) {
      if(checkProv(val.substring(0,2))) {
        return true;
      }
    }
  }
  return false;
}
export default {
  required:{ required: true, message: '请输入内容', trigger: 'blur' },
  requiredChange:{ required: true, message: '请选择内容', trigger: ['change', 'blur'] },
  idcard:{validator: (rule, value,callback) => {
    if(!value){
      return callback()
    }
    // 校验15位 基本校验
      if(value&& value.length===15){
        if(/^[1-9]\d{5}\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/.test(value)){
          callback();
        }else{
          callback('请输入正确的身份证号');  // reject with error message
        }
      }else{
        // 18位的复杂精确校验
        if (!checkID(value)) {
          callback('请输入正确的身份证号');  // reject with error message
        } else {
          callback();
        }
      }
    },message: '请输入正确的身份证号', trigger: 'blur'},
  // phone:{pattern:/^1(3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])\d{8}$/, message: '请输入正确的手机号', trigger: 'blur'},
  phone:{pattern:/^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: '请输入正确的手机号', trigger: 'blur'},
  number:{pattern:/^(\-|\+)?\d+(\.\d+)?$/, message: '请输入正确数字', trigger: 'blur'},
  email:{pattern:/^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/, message: '请输入正确的email', trigger: 'blur'},
  postalCode:{pattern:/^[1-9]\d{5}$/, message: '请输入正确的邮政编码', trigger: 'blur'},
}
